// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"296b34e4","53":"3b892440","438":"2d2c6943","480":"84ce426e","662":"5eeeaed5","839":"20e00ee5","869":"bef1e709","980":"0138e16f","993":"5963fcde"}[chunkId] + ".chunk.js";
};